import React from "react";

import SelectMenu from "../utility/select-menu";
import Spinner from "../utility/spinner";
// import "../../../style/cash-memo.css";
import sign from "../../../style/sign_7.png";
import { DD_MM_YY } from "../utility/util-methods";
import Xrand from "../utility/xrand";

import rq from "../utility/rq.js";

export default class InstantCashMemo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            productList: [],
            selectedProduct: null,
            selectedDate: null,
            selectedProductSellingPrice: 0,
            showSpinner: false,
            includeCreditVehicles: false,
            finalQuantityToGenerateSlip: 0,
            additionalQuantity: "",
            finalDataToGenerate: []
        };
        //  console.log(this.state);
        this.creditVehicleData = [];
        this.totalCreditQuantity = 0;
        this.handleDateSelect = this.handleDateSelect.bind(this);
        this.onProductSelect = this.onProductSelect.bind(this);
        this.onPriceChange = this.onPriceChange.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.handleQuantityChange = this.handleQuantityChange.bind(this);
        this.q = 0;
    }

    componentDidMount() {
        rq.getJsonData("/api/v1/products").then((data) => {
            this.setState({ productList: data });
        }).catch(() => {
            alert("failed to get products");
        });
    }

    resetData() {
        this.totalCreditQuantity = 0;
        this.creditVehicleData = [];
        this.setState({ additionalQuantity: "", includeCreditVehicles: false, finalDataToGenerate: [] });
    }

    handleDateSelect(e) {

        if (this.state.selectedProduct === null) {
            alert("Please select product first");
            e.target.value = "";
        } else {
            const dt = e.target.value;
            this.resetData();
            rq.getJsonData(`/api/v1/products-rate-by-shiftDate/${e.target.value}`).then((data) => {
                //  const selectedProduct = { ...this.state.selectedProduct };

                data.forEach((product) => {

                    if (this.state.selectedProduct.productId === product.productId) {

                        this.setState({ selectedProductSellingPrice: product.sellingPrice, selectedDate: dt });
                    }

                });

            }).catch((err) => {
                console.log("got error in prodduct price");
            });
        }

    }

    onProductSelect(product) {

        if (product) {
            this.setState({ selectedProduct: product }, () => {
                if (this.state.selectedDate) {
                    this.handleDateSelect({ target: { value: this.state.selectedDate } });
                }
            });

        }

    }

    onPriceChange(e) {
        this.setState({ selectedProductSellingPrice: e.target.value });

    }

    handleCheckboxChange() {
        this.resetData();
        if (this.state.includeCreditVehicles === false) {
            this.setState({ showSpinner: true, includeCreditVehicles: true, finalDataToGenerate: [] });


            rq.getJsonData(`/api/v1/credit-report-between-dates?from=${this.state.selectedDate}&to=${this.state.selectedDate}&id=false`).then((creditVehicleData) => {

                // need this map because the api provides all prodcut data including ms and hs
                for (let i = 0; i < creditVehicleData.length; i++) {
                    const data = creditVehicleData[i];
                    if (data.productName === this.state.selectedProduct.productName) {
                        this.totalCreditQuantity += data.quantity;
                        this.creditVehicleData.push({
                            customerName: data.firmName,
                            date: data.shiftDate,
                            slNo: i,
                            price: this.state.selectedProductSellingPrice,
                            productName: this.state.selectedProduct.productName,
                            vehicleNumber: data.vehicle,
                            quantity: data.quantity,
                            amount: data.amount
                        });
                    }
                }

                this.totalCreditQuantity = parseFloat(this.totalCreditQuantity.toFixed(2));

                this.setState({ showSpinner: false, finalQuantityToGenerateSlip: this.totalCreditQuantity, additionalQuantity: "" });


                console.log(this.creditVehicleData);

            }).catch((err) => {
                console.log(err);
                alert("erro occured in fetching credit vehicle data");
                this.setState({ showSpinner: false });
            });
        } else {
            this.totalCreditQuantity = 0;
            this.setState({ includeCreditVehicles: false, finalDataToGenerate: [] });
        }

    }
    handleQuantityChange(e) {
        let value = e.target.value;
        if (value) {

            //  console.log(parseFloat(value));
            //    console.log(this.creditVehicleData);
            this.setState({ additionalQuantity: value, finalQuantityToGenerateSlip: parseFloat(this.totalCreditQuantity) + parseFloat(value) });
        } else {
            this.setState({ additionalQuantity: "", finalQuantityToGenerateSlip: parseFloat(this.totalCreditQuantity) + 0 });
        }
    }

    generateRandomDataForHS(toAmount) {

        let randomData = [];
        let incrementingAmount = 0;
        const xrand = new Xrand(0, 193);
        const xrand2 = new Xrand(0, 193);
        let qt = 0;
        while (incrementingAmount < toAmount) {

            let x = this.getRandomInt(200, 20000);
            console.log(x, toAmount, incrementingAmount, toAmount - incrementingAmount);
            if (x > (toAmount - incrementingAmount)) {

                x = toAmount - incrementingAmount;
                console.log("inside if x ", x);
                incrementingAmount += x;
                console.log("incrementAmount ", incrementingAmount);
            } else {
                console.log("inside else x", x);
                incrementingAmount += x;
                console.log("incrementAmount ", incrementingAmount);
            }

            let index = xrand.generate() || xrand2.generate();


            let obj = { ...fakeDataHS[index] };
            let qnt = (x / this.state.selectedProductSellingPrice);

            console.log(x, qnt);
            qt += qnt;
            obj.date = this.state.selectedDate;
            obj.price = this.state.selectedProductSellingPrice;
            obj.quantity = qnt;
            obj.amount = x;



            // obj = Object.assign(
            //     obj, {
            //     date: this.state.selectedDate,
            //     price: this.state.selectedProductSellingPrice,
            //     quantity: (x / this.state.selectedProductSellingPrice),
            //     amount: x
            // });
            randomData.push(obj);

        }

        let totalQt = 0;
        let totalAmount = 0;

        for (let i = 0; i < randomData.length; i++) {
            totalQt += randomData[i].quantity;
            totalAmount += randomData[i].amount;
        }
        console.log("Total Quantity", totalQt, qt, totalAmount, randomData.length);

        return randomData;

    }

    getRandomInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min) + min); // The maximum is exclusive and the minimum is inclusive
    }
    generateCashMemo() {
        if (this.state.additionalQuantity > 0) {
            // if there is additional quantity nedd to insert some fake data


            if (this.state.selectedProduct.productName === "HS") {
                let quantiy = parseFloat(this.state.additionalQuantity);

                const randomData = this.generateRandomDataForHS(quantiy * this.state.selectedProductSellingPrice);

                const finalData = [...this.creditVehicleData, ...randomData];

                this.setState({ finalDataToGenerate: finalData });
            }


        } else {
            this.setState({ finalDataToGenerate: this.creditVehicleData });
        }
    }

    render() {
        return (
            <div>
                <div id="formHolder">
                    <h2>Instant Cash Memo Generation</h2>
                    <table className="formTable">
                        <tbody>
                            <tr>
                                <td>
                                    <p className="label">Select Product</p>
                                    <SelectMenu
                                        data={this.state.productList}
                                        onSelect={this.onProductSelect}
                                        tabIndex="2"
                                        text="Select a product"
                                        // onBlur={this.validate.bind(this, "productId", "creditDetail")}
                                        ky="productId"
                                        vl="productName"
                                        reset={this.producdMenuReset}
                                        rex={(element) => {
                                            this.procductSelect = element;
                                        }}
                                    />
                                </td>
                                <td>
                                    <p className="label">Select Date</p>
                                    <input
                                        tabIndex="3"
                                        type="date"
                                        className="formControl inputBox"
                                        onChange={this.handleDateSelect}
                                        ref="slipDate"


                                    />

                                </td>

                                <td>
                                    <p className="label">Product Price</p>
                                    <input
                                        tabIndex="6"
                                        type="text"
                                        className="formControl inputBox"
                                        placeholder="Enter Price"
                                        // onKeyUp={this.handleQuantity.bind(this)}
                                        value={this.state.selectedProductSellingPrice}
                                        ref="quantity"
                                        style={{ width: "320px" }}
                                        onChange={this.onPriceChange}
                                    />

                                </td>
                                {this.state.selectedProduct && this.state.selectedDate &&
                                    <td>
                                        <p className="label">Include Credit Vehicles</p>
                                        <input
                                            type="checkbox"
                                            checked={this.state.includeCreditVehicles}
                                            onChange={this.handleCheckboxChange}
                                        />
                                    </td>
                                }


                            </tr>
                            <tr>
                                <td>

                                    <p className="label" style={{ color: this.totalCreditQuantity > 0 ? "red" : "none" }}>{this.creditVehicleData.length > 0 ? `Found ${this.totalCreditQuantity.toFixed(2)} liters ${this.state.selectedProduct.productName} in credit, Enter  Additional Quantity ` : `Found 0 credit data Enter total quantity`}</p>
                                    <input
                                        tabIndex="6"
                                        type="text"
                                        className="formControl inputBox"
                                        placeholder="Enter Qunatiy Max 6000 liters"
                                        // onKeyUp={this.handleQuantity.bind(this)}
                                        value={this.state.additionalQuantity}
                                        onChange={this.handleQuantityChange}
                                        ref="quantity"
                                        style={{ width: "320px" }}
                                    />

                                </td>
                                <td style={{ display: "flex", flexDirection: "column" }}>
                                    <button
                                        tabIndex="11"
                                        className="btn btnOk btnRight"
                                        onClick={() => this.generateCashMemo()}
                                        ref="save"
                                        style={{ textTransform: "uppercase" }}
                                    >
                                        Click to generate <span style={{ color: "red", fontWeight: "bold" }}>
                                            {/* credit {this.totalCreditQuantity} ---- */}
                                            {((parseFloat(this.state.additionalQuantity) || 0) + (parseFloat(this.totalCreditQuantity) || 0)).toFixed(2)}
                                        </span> ltrs of <span style={{ color: "red", fontWeight: "bold" }}>{this.state.selectedProduct ? this.state.selectedProduct.productName : ""}</span> Cash Memo

                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    {this.state.showSpinner ? <Spinner></Spinner> : null}

                </div>

                {this.state.finalDataToGenerate.length > 0 ?
                    <h2 className="total">Total Quantity {((parseFloat(this.state.additionalQuantity) || 0) + (parseFloat(this.totalCreditQuantity) || 0)).toFixed(2)} liters of {this.state.selectedProduct.productName}</h2> : null}
                <div className="cashMemocontainer">

                    {this.state.finalDataToGenerate.map((data, index) => {
                        this.q += data.quantity;
                        return (<div className="memo" key={index}>
                            <div className="header">
                                <h2 className="title">Tunga Filling Station</h2>
                                <p className="address">Bankadhara Chhak, Talcher</p>
                                <p className="dealer">Dealer: BPCL</p>
                                <p className="tin">TIN: 21083505292</p>
                            </div>
                            <div className="date">
                                <p>Date:{DD_MM_YY(data.date)}</p>
                                <p>SL No: {index + 1}</p>
                            </div>
                            <div className="info">
                                <p>Customer Name:</p>
                                <p className="cName"><span className="bold" style={{ fontSize: data.customerName.length > 15 ? "10pt" : "12pt" }}>{data.customerName.length > 20 ? data.customerName.substring(0, 20) + "..." : data.customerName}</span></p>
                                <p>Vechile No:<span className="bold">{data.vehicleNumber}</span></p>
                                <p>Product: <span className="bold">{data.productName}</span></p>
                                <p>Price/Liter: <span className="bold">Rs. {data.price}</span></p>
                                <p>Quantity: <span className="bold">{data.quantity.toFixed(2)} liter</span></p>
                                <p>Amount: <span className="bold">Rs. {data.amount.toFixed(2)}</span></p>
                            </div>
                            <div className="sign">
                                <p>Signature of the authorised Person</p>
                                <img src={sign} />
                            </div>
                        </div>);
                    })}


                    <h2 className="totalGenerated">Total{this.q.toFixed(2)}</h2>


                </div>

            </div>
        );
    }
}


const fakeDataHS = [
    { vehicleNumber: 'OD35C3331', customerName: 'A Sahoo' },
    { vehicleNumber: 'OD35C7117', customerName: 'Manoj Das' },
    { vehicleNumber: 'OR04F3245', customerName: 'Rashmi' },
    { vehicleNumber: 'OD35D7617', customerName: 'Gagan' },
    { vehicleNumber: 'OD35C2015', customerName: 'K. Behera' },
    { vehicleNumber: 'OD35C5383', customerName: 'R. Das' },
    { vehicleNumber: 'OD35B8899', customerName: 'P Pradhan' },
    { vehicleNumber: 'OD35B8441', customerName: 'Ramesh Sahoo' },
    { vehicleNumber: 'OD35D8441', customerName: 'Vipin Das' },
    { vehicleNumber: 'OD35D1499', customerName: 'Rahul Ray' },
    { vehicleNumber: 'OD19F9633', customerName: 'K. Behera' },
    { vehicleNumber: 'OD35B6399', customerName: 'Dipip Jena' },
    { vehicleNumber: 'OD35B8611', customerName: 'Raman Sahoo' },
    { vehicleNumber: 'OD35D8611', customerName: 'Jagidish Behera' },
    { vehicleNumber: 'OD35D7042', customerName: 'K kalpa' },
    { vehicleNumber: 'OD35B5427', customerName: 'T Rao' },
    { vehicleNumber: 'OD35C4326', customerName: 'J. Sahoo' },
    { vehicleNumber: 'OD19G0017', customerName: 'Rama Nayak' },
    { vehicleNumber: 'OD35D0599', customerName: 'A Sahoo' },
    { vehicleNumber: 'OD35B9979', customerName: 'S Jena' },
    { vehicleNumber: 'OD35D0412', customerName: 'Raja' },
    { vehicleNumber: 'OD19M3017', customerName: 'Pintu Sahu' },
    { vehicleNumber: 'OD35D8379', customerName: 'Mantu' },
    { vehicleNumber: 'OR04E4111', customerName: 'Ranu Jena' },
    { vehicleNumber: 'OR19G7047', customerName: 'Manas Das' },
    { vehicleNumber: 'OD35C1888', customerName: 'Manoj Das' },
    { vehicleNumber: 'OD35E3339', customerName: 'R Tripathy' },
    { vehicleNumber: 'OD35C9888', customerName: 'Rashmi Jena' },
    { vehicleNumber: 'OD35C8383', customerName: 'T Tripathi' },
    { vehicleNumber: 'OD35C4888', customerName: 'Mantu' },
    { vehicleNumber: 'OD35C4453', customerName: 'R Jena' },
    { vehicleNumber: 'OD35B9748', customerName: 'Rama Nayak' },
    { vehicleNumber: 'OD35C8379', customerName: 'Abinash' },
    { vehicleNumber: 'OD35C6362', customerName: 'Kalu' },
    { vehicleNumber: 'OD35C7926', customerName: 'Patia Pradhan' },
    { vehicleNumber: 'OD35D3133', customerName: 'Deepak Pradhan' },
    { vehicleNumber: 'OD35D2225', customerName: 'Ramesh Sahoo' },
    { vehicleNumber: 'OR11J5039', customerName: 'Kalia Malla' },
    { vehicleNumber: 'OD35B2723', customerName: 'Mantu Nanda' },
    { vehicleNumber: 'OD35C2723', customerName: 'Santohs Das' },
    { vehicleNumber: 'OD35D2399', customerName: 'Kalia Debta' },
    { vehicleNumber: 'OD35D8121', customerName: 'Ramesh Jena' },
    { vehicleNumber: 'OR19K9978', customerName: 'Mantu ' },
    { vehicleNumber: 'OD19J2723', customerName: 'Kalinga Sahoo' },
    { vehicleNumber: 'OD35C3123', customerName: 'Radhakant Ratha' },
    { vehicleNumber: 'OD19B0017', customerName: 'Probodh Jena' },
    { vehicleNumber: 'OD35B0627', customerName: 'Bira Sahoo' },
    { vehicleNumber: 'OD35A7127', customerName: 'Abinash Kara' },
    { vehicleNumber: 'OD35C2127', customerName: 'K Sahu' },
    { vehicleNumber: 'OD35C3339', customerName: 'R Pradhan' },
    { vehicleNumber: 'OD35B9089', customerName: 'T Jena' },
    { vehicleNumber: 'OD35D2516', customerName: 'M Jena' },
    { vehicleNumber: 'OD35B7888', customerName: 'Lalit Pradhan' },
    { vehicleNumber: 'OD35D2666', customerName: 'T Sahu' },
    { vehicleNumber: 'OD35B6888', customerName: 'K Nanda' },
    { vehicleNumber: 'OD29D7786', customerName: 'J Behera' },
    { vehicleNumber: 'OD35B8612', customerName: 'Maharga Jena' },
    { vehicleNumber: 'OD35A7566', customerName: 'P Behera' },
    { vehicleNumber: 'OD19H6866', customerName: 'S Sahu' },
    { vehicleNumber: 'OD35-5167', customerName: 'K Nanda' },
    { vehicleNumber: 'OD06C6866', customerName: 'Bapi Jena' },
    { vehicleNumber: 'OD35B8768', customerName: 'Bapin Bhukta' },
    { vehicleNumber: 'OR19G9437', customerName: 'Kamakhya Behera' },
    { vehicleNumber: 'OD35D2015', customerName: 'P Dehury' },
    { vehicleNumber: 'OD35D3993', customerName: 'J Nanda' },
    { vehicleNumber: 'OD35E1724', customerName: 'K Dehury' },
    { vehicleNumber: 'OR19G7247', customerName: 'S Sharma' },
    { vehicleNumber: 'OD35D1724', customerName: 'Kalia' },
    { vehicleNumber: 'OD35A7758', customerName: 'S Mishrqa' },
    { vehicleNumber: 'OD35D2489', customerName: 'P Tripathi' },
    { vehicleNumber: 'OD19E7429', customerName: 'J Jena' },
    { vehicleNumber: 'OD35C2666', customerName: 'Abhi das' },
    { vehicleNumber: 'OD35C2015', customerName: 'gandu khanduala' },
    { vehicleNumber: 'OD35C5311', customerName: 'munga sahoo' },
    { vehicleNumber: 'OD35C6777', customerName: 'bamuru kumar' },
    { vehicleNumber: 'OD35B5777', customerName: 'rabi behera' },
    { vehicleNumber: 'OD35C3927', customerName: 'murali behera' },
    { vehicleNumber: 'OD35C4777', customerName: 'jhumara tunga' },
    { vehicleNumber: 'OD35B3017', customerName: 'panu jena' },
    { vehicleNumber: 'OD19M3737', customerName: 'samir pradhan' },
    { vehicleNumber: 'OD35E3737', customerName: 'amara sahoo' },
    { vehicleNumber: 'OD35D2399', customerName: 'bapi gochhayat' },
    { vehicleNumber: 'OD35C0606', customerName: 'baikuntha jena' },
    { vehicleNumber: 'OD35B8899', customerName: 'KK Jena' },
    { vehicleNumber: 'OD35D2225', customerName: 'Biplab Sahu' },
    { vehicleNumber: 'OD35C3331', customerName: 'Ramakanta' },
    { vehicleNumber: 'OD35B6399', customerName: 'Lalit ' },
    { vehicleNumber: 'OD35C4326', customerName: 'Nilu' },
    { vehicleNumber: 'OD19N3737', customerName: 'Rabin' },
    { vehicleNumber: 'OD35D8441', customerName: 'Bikina Bhutia' },
    { vehicleNumber: 'OD35B8441', customerName: 'Anada Sahu' },
    { vehicleNumber: 'OD35D7042', customerName: 'P Nanda' },
    { vehicleNumber: 'OR19K9978', customerName: 'Ramesh Kanta' },
    { vehicleNumber: 'OD35C9950', customerName: 'Abinash Kara' },
    { vehicleNumber: 'OD35B8868', customerName: 'Rama Jena' },
    { vehicleNumber: 'OD35A7068', customerName: 'Pabitra ' },
    { vehicleNumber: 'OD35C5100', customerName: 'Priyansu' },
    { vehicleNumber: 'OD35B8611', customerName: 'Kamakhya' },
    { vehicleNumber: 'OD35C1888', customerName: 'Lipu ' },
    { vehicleNumber: 'OD35C9888', customerName: 'Abhay Kumar' },
    { vehicleNumber: 'OD35D8611', customerName: 'Rakesh ' },
    { vehicleNumber: 'OD35D8121', customerName: 'Aru Jena' },
    { vehicleNumber: 'OD29D7786', customerName: 'K Kumar' },
    { vehicleNumber: 'OD19M3017', customerName: 'D Dehury' },
    { vehicleNumber: 'OD35C5101', customerName: 'K Prasad' },
    { vehicleNumber: 'OD35B8612', customerName: 'J Tripathy' },
    { vehicleNumber: 'OD19G0017', customerName: 'L Behera' },
    { vehicleNumber: 'OD19E7429', customerName: 'R Pradhan' },
    { vehicleNumber: 'OD35D0599', customerName: 'K Jena' },
    { vehicleNumber: 'OD35B9748', customerName: 'B Jena' },
    { vehicleNumber: 'OD19E3737', customerName: 'K Das' },
    { vehicleNumber: 'OD35B9979', customerName: 'J Sahoo' },
    { vehicleNumber: 'OD35C6537', customerName: 'Samir pradhan' },
    { vehicleNumber: 'OR04E4111', customerName: 'Deepak Pradhan' },
    { vehicleNumber: 'OD19G3737', customerName: 'Ramesh Sahoo' },
    { vehicleNumber: 'OD35D5152', customerName: 'Kalia Malla' },
    { vehicleNumber: 'OD35C6362', customerName: 'Mantu Nanda' },
    { vehicleNumber: 'OD35D0412', customerName: 'Santohs Das' },
    { vehicleNumber: 'OD35C3927', customerName: 'Kalia Debta' },
    { vehicleNumber: 'OD19L6654', customerName: 'Ramesh Jena' },
    { vehicleNumber: 'OD35D3993', customerName: 'Mantu ' },
    { vehicleNumber: 'OD35D2015', customerName: 'Kalinga Sahoo' },
    { vehicleNumber: 'OD19B0017', customerName: 'Radhakant Ratha' },
    { vehicleNumber: 'OD35C2015', customerName: 'Probodh Jena' },
    { vehicleNumber: 'OD35C4888', customerName: 'Bira Sahoo' },
    { vehicleNumber: 'OR19K9978', customerName: 'Abinash Kara' },
    { vehicleNumber: 'OD35D3133', customerName: 'K Sahu' },
    { vehicleNumber: 'OD35C7117', customerName: 'R Pradhan' },
    { vehicleNumber: 'OD35D7617', customerName: 'T Jena' },
    { vehicleNumber: 'OD35D3995', customerName: 'M Jena' },
    { vehicleNumber: 'OD35D3849', customerName: 'Lalit Pradhan' },
    { vehicleNumber: 'OD35A7758', customerName: 'T Sahu' },
    { vehicleNumber: 'OD35C5311', customerName: 'K Nanda' },
    { vehicleNumber: 'OD35D7178', customerName: 'J Behera' },
    { vehicleNumber: 'OD35C2666', customerName: 'Maharga Jena' },
    { vehicleNumber: 'OD19H6866', customerName: 'P Behera' },
    { vehicleNumber: 'OD35D2666', customerName: 'S Sahu' },
    { vehicleNumber: 'OR04F3245', customerName: 'Manoj Das' },
    { vehicleNumber: 'OD06C6866', customerName: 'Rashmi' },
    { vehicleNumber: 'OD35D8441', customerName: 'Gagan' },
    { vehicleNumber: 'OD35B8441', customerName: 'K. Behera' },
    { vehicleNumber: 'OD35C3339', customerName: 'R. Das' },
    { vehicleNumber: 'OD35C7926', customerName: 'P Pradhan' },
    { vehicleNumber: 'OD19F9633', customerName: 'Ramesh Sahoo' },
    { vehicleNumber: 'OD19J2723', customerName: 'Vipin Das' },
    { vehicleNumber: 'OD35C2723', customerName: 'Rahul Ray' },
    { vehicleNumber: 'OD29D7786', customerName: 'K. Behera' },
    { vehicleNumber: 'OD19G3737', customerName: 'Dipip Jena' },
    { vehicleNumber: 'OD19E7429', customerName: 'Raman Sahoo' },
    { vehicleNumber: 'OD35D8611', customerName: 'Jagidish Behera' },
    { vehicleNumber: 'OD35B8611', customerName: 'K Das' },
    { vehicleNumber: 'OR19K9978', customerName: 'J Tripathy' },
    { vehicleNumber: 'OD35E3737', customerName: 'M Behera' },
    { vehicleNumber: 'OD35C3331', customerName: 'L Das' },
    { vehicleNumber: 'OD35C0606', customerName: 'J Nanda' },
    { vehicleNumber: 'OD19M3737', customerName: 'Kabi Das' },
    { vehicleNumber: 'OD35B2723', customerName: 'T Dehury' },
    { vehicleNumber: 'OD19N3737', customerName: 'Jitu Pradhan' },
    { vehicleNumber: 'OD35B3017', customerName: 'Jitu ' },
    { vehicleNumber: 'OR19G9437', customerName: 'Pranothos Ray' },
    { vehicleNumber: 'OD35B9979', customerName: 'Rameswar Behera' },
    { vehicleNumber: 'OD35B8868', customerName: 'Kamkya Das' },
    { vehicleNumber: 'OD35D0412', customerName: 'Binod Das' },
    { vehicleNumber: 'OD35D1373', customerName: 'Ajay Das' },
    { vehicleNumber: 'OD35A7068', customerName: 'Sanjay Das' },
    { vehicleNumber: 'OR19G7247', customerName: 'Arkhita Jena' },
    { vehicleNumber: 'OD35C8383', customerName: 'Abhi Das' },
    { vehicleNumber: 'OD35C8379', customerName: 'Jagidish Behera' },
    { vehicleNumber: 'OD35B9089', customerName: 'Mantu Setha' },
    { vehicleNumber: 'OD35D2489', customerName: 'Abhay Das' },
    { vehicleNumber: 'OD19M3017', customerName: 'Bibhuti Tripathi' },
    { vehicleNumber: 'OR19H2572', customerName: 'Rakesh Nanda' },
    { vehicleNumber: 'OD35C9968', customerName: 'Prabin Jena' },
    { vehicleNumber: 'OD35A7127', customerName: 'Prasuram Barik' },
    { vehicleNumber: 'OD35C4453', customerName: 'Ananda Das' },
    { vehicleNumber: 'OD35C3927', customerName: 'Kalia Debta' },
    { vehicleNumber: 'OD35B8612', customerName: 'Ramesh Jena' },
    { vehicleNumber: 'OD35D3849', customerName: 'Mantu ' },
    { vehicleNumber: 'OD35D3995', customerName: 'Kalinga Sahoo' },
    { vehicleNumber: 'OD19B0017', customerName: 'Radhakant Ratha' },
    { vehicleNumber: 'OD5D7617', customerName: 'Probodh Jena' },
    { vehicleNumber: 'OD35D7172', customerName: 'Bira Sahoo' },
    { vehicleNumber: 'OD19M4453', customerName: 'Abinash Kara' },
    { vehicleNumber: 'OD35D3243', customerName: 'K Sahu' },
    { vehicleNumber: 'OD35C5101', customerName: 'R Pradhan' },
    { vehicleNumber: 'OD35B5427', customerName: 'T Jena' },
    { vehicleNumber: 'OD19E3737', customerName: 'M Jena' },
    { vehicleNumber: 'OD35B8121', customerName: 'Lalit Pradhan' },
    { vehicleNumber: 'OD35D8121', customerName: 'T Sahu' },
    { vehicleNumber: 'OD35B8899', customerName: 'KK Das' },
    { vehicleNumber: 'OD35D3993', customerName: 'Abhay Jena' },
    { vehicleNumber: 'OD35D3133', customerName: 'Rakesh Khandual' },
    { vehicleNumber: 'OD35C2015', customerName: 'Bablu Behera' },
    { vehicleNumber: 'OD35D2015', customerName: 'Sibananda' },
    { vehicleNumber: 'OD35C2727', customerName: 'Litan Bhutia' },
    { vehicleNumber: 'OD35C5100', customerName: 'Gauranga Das' },
];


// WEBPACK FOOTER //
// ./src/jsx/components/fragments/instant-cash-memo.jsx